import { render, staticRenderFns } from "./CreateCoupon.vue?vue&type=template&id=2911d060&scoped=true"
import script from "./CreateCoupon.vue?vue&type=script&lang=js"
export * from "./CreateCoupon.vue?vue&type=script&lang=js"
import style0 from "./CreateCoupon.vue?vue&type=style&index=0&id=2911d060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2911d060",
  null
  
)

export default component.exports